export default [
  {
    label: `Add a custom ESLint config`,
    value: `eslint`,
  },
  {
    label: `Add Jest`,
    value: `jest`,
  },
  {
    label: `Add Gatsby Image`,
    value: `gatsby-image`,
  },
  // Waiting on joi2graphql support for Joi.object().unknown()
  // with a JSON type.
  // {
  // label: "Automatically run Prettier on commits",
  // value: "prettier-git-hook.mdx",
  // },
  {
    label: `Add Gatsby Theme Blog`,
    value: `gatsby-theme-blog`,
  },
  {
    label: `Add Gatsby Theme Blog Core`,
    value: `gatsby-theme-blog-core`,
  },
  {
    label: `Add Gatsby Theme Notes`,
    value: `gatsby-theme-notes`,
  },
  {
    label: `Add persistent layout component with gatsby-plugin-layout`,
    value: `gatsby-plugin-layout`,
  },
  {
    label: `Add Theme UI`,
    value: `theme-ui`,
  },
  {
    label: `Add Chakra UI`,
    value: `chakra-ui`,
  },
  {
    label: `Add Emotion`,
    value: `emotion`,
  },
  {
    label: `Add support for MDX Pages`,
    value: `mdx-pages`,
  },
  {
    label: `Add support for MDX Pages with images`,
    value: `mdx-images`,
  },
  {
    label: `Add Styled Components`,
    value: `styled-components`,
  },
  {
    label: `Add Tailwind`,
    value: `tailwindcss`,
  },
  {
    label: `Add Sass`,
    value: `sass`,
  },
  {
    label: `Add Typescript`,
    value: `typescript`,
  },
  {
    label: `Add Cypress testing`,
    value: `cypress`,
  },
  {
    label: `Add animated page transition support`,
    value: `animated-page-transitions`,
  },
  {
    label: `Add plugins to make site a PWA`,
    value: `pwa`,
  },
  {
    label: `Add React Helmet`,
    value: `gatsby-plugin-react-helmet`,
  },
  {
    label: `Add GitHub Pages deployment with Travis CI`,
    value: `travis-deploy-github-pages`,
  },
  {
    label: `Add e-commerce powered by Snipcart`,
    value: `snipcart.mdx`,
  },
  {
    label: `Add Storybook - JavaScript`,
    value: `storybook-js`,
  },
  {
    label: `Add Storybook - TypeScript`,
    value: `storybook-ts`,
  },
  {
    label: `Add AVA`,
    value: `ava`,
  },
  {
    label: `Add Preact`,
    value: `preact`,
  },
  {
    label: `Add GitLab CI/CD`,
    value: `gitlab-ci-cd`,
  },
]
